export const getUniqueLabel = (base: string, existingLabels: string[]): string => {
  const usedLabels = new Set(existingLabels.map((label) => label.toLowerCase()));
  if (!usedLabels.has(base.toLowerCase())) {
    return base;
  }
  let number = 2;
  while (usedLabels.has(`${base} ${number}`.toLowerCase())) {
    number++;
  }
  return `${base} ${number}`;
};
